var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoveIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "145.988 52.672 27.78 27.943",
    style: {
      enableBackground: "new 0 0 320 132"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2B2B2B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    transform: "translate(-384.432 -3951.842)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_zoom_out_map_24px",
    className: "st0",
    d: "M540.2,4009.9l3.2,0l0,4l2,0l-0.1-4l3.2,0l-4.2-4.2L540.2,4009.9z M536.2,4022.3 l0-3.2l4,0.1l0-2l-4,0l0-3.2l-4.1,4.1L536.2,4022.3z M548.7,4026.6l-3.2,0l0-4l-2,0l0.1,4l-3.2,0l4.2,4.2L548.7,4026.6z M552.7,4014.2l0,3.2l-4-0.1l0,2l4,0l0,3.2l4.1-4.1L552.7,4014.2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoveIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/moveIcon.357dfa87c378d5701828f71170907495.svg";